;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { useSyncExternalStore } from 'react';

import { LOCAL_STORAGE_CHANGE_EVENT_NAME } from '@/consts/localStorage';
import { getLocalStorageValue } from '@/utils/localStorage';
import { parseJson } from '@/utils/misc';

const subscribe = (onStoreChange: () => void): (() => void) => {
  const handleDifferentContextChange = (event: StorageEvent): void => {
    if (event.storageArea === localStorage) {
      onStoreChange();
    }
  };

  window.addEventListener(LOCAL_STORAGE_CHANGE_EVENT_NAME, onStoreChange);
  window.addEventListener('storage', handleDifferentContextChange);

  return (): void => {
    window.removeEventListener(LOCAL_STORAGE_CHANGE_EVENT_NAME, onStoreChange);
    window.removeEventListener('storage', handleDifferentContextChange);
  };
};

// useSyncExternalStore compares snapshots by identity and re-reads on every
// render, so parseJson's freshly allocated result has to be memoised against the
// raw string it came from — otherwise every render looks like a store change.
const snapshots = new Map<string, { raw: string | null; parsed: unknown }>();

const getSnapshot = <T>(key: string): T | null => {
  const raw = getLocalStorageValue(key);
  const cached = snapshots.get(key);

  if (cached && cached.raw === raw) {
    return cached.parsed as T | null;
  }

  const parsed = parseJson<T>(raw);

  snapshots.set(key, { raw, parsed });

  return parsed;
};

const getServerSnapshot = (): null => null;

export const useLocalStorageValue = <T>(key: string): T | null =>
  useSyncExternalStore(subscribe, () => getSnapshot<T>(key), getServerSnapshot);
